import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConnected: true, // Mock initial state
  isPaid: false,
  activeNumberId: "1",
  stats: {
    messagesSent: 12458,
    deliveredPercentage: 98.2,
    activeContacts: 3240,
    campaignsCount: 24
  },
  connectedNumbers: [
    { id: "1", number: "+91 98765 43210", label: "Sales", status: "active" },
    { id: "2", number: "+91 87654 32109", label: "Support", status: "active" },
  ],
  recentCampaigns: [
    { id: 1, name: "Diwali Festival Sale", sent: 2400, delivered: 2350, status: "completed", date: "Oct 28", spent: 1920 },
    { id: 2, name: "Product Launch", sent: 1200, delivered: 1180, status: "completed", date: "Oct 25", spent: 960 },
    { id: 3, name: "Weekly Newsletter", sent: 850, delivered: 0, status: "scheduled", date: "Nov 1", spent: 0 },
  ],
  loading: false,
  error: null,
};

const whatsappSlice = createSlice({
  name: 'whatsappnew',
  initialState,
  reducers: {
    setConnected: (state, action) => {
      state.isConnected = action.payload;
    },
    setActiveNumber: (state, action) => {
      state.activeNumberId = action.payload;
    },
    markAsPaid: (state) => {
      state.isPaid = true;
    },
    // Saga will dispatch this on success
    fetchDashboardSuccess: (state, action) => {
      state.stats = action.payload.stats;
      state.recentCampaigns = action.payload.campaigns;
      state.loading = false;
    },
    fetchDashboardStart: (state) => {
      state.loading = true;
    }
  }
});

export const { setConnected, setActiveNumber, markAsPaid, fetchDashboardSuccess, fetchDashboardStart } = whatsappSlice.actions;
export default whatsappSlice.reducer;